export default __webpack_public_path__ + "static/media/c4.d389d182.png";